import React from 'react';
import { Container,Row } from 'react-bootstrap';

export const Segmentacion = ({state,updateState}) => {
  const {openMenu} = state;
  return (
    <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
      <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
        <Container fluid>
          <h1 className="ws_title_header">Segmentación</h1>
          <Row>
            
          </Row>
        </Container>
      </div>
    </div>
  )
}